import {identity} from 'lodash';
import {ACTION_INVALID_FIELD_FOUND, ACTION_REMOVE_INVALID_FIELD, ACTION_REPLACE_INVALID_FIELD} from '../actions/requiredUserActions';
import { ACTION_REMOVE_CONDITION } from '../actions/query';

const DEFAULT_STATE = {
    invalidFields: [],
};

export default function requiredUserActionsReducer(state, action) {
    if (!state) {
        state = {...DEFAULT_STATE};
    }

    switch (action.type) {
        case ACTION_INVALID_FIELD_FOUND:
            state = {
                ...state,
                invalidFields: [
                    ...state.invalidFields,
                    {
                        category: action.category,
                        conditionIndex: action.conditionIndex,
                        subCondition: action.subCondition,
                    },
                ],
            };
            break;
        case ACTION_REMOVE_INVALID_FIELD:
        case ACTION_REPLACE_INVALID_FIELD:
            state = {
                ...state,
                invalidFields: state.invalidFields.filter(invf => invf.category != action.category || invf.subCondition.field != action.field),
            };
            break;
        case ACTION_REMOVE_CONDITION:
            state = {
                ...state,
                invalidFields: state.invalidFields
                    .map(invf => {
                        if (invf.conditionIndex > action.conditionIndex) {
                            // invalid field is from condition after the one removed: decrease index
                            return {
                                ...invf,
                                conditionIndex: invf.conditionIndex - 1,
                            };
                        } else if (invf.conditionIndex < action.conditionIndex) {
                            // invalid field is from condition before the one remove: no change
                            return invf;
                        } /* invf.conditionIndex == action.conditionIndex */ else {
                            // field is from the removed condition: remove (return null and filter will deal with it next)
                            return null;
                        }
                    })
                    .filter(identity),
            };
    }

    return state;
}
